import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

interface EditInvoicePayload {
  discountedPrice?: number;
  note?: string;
  statusOfBill?: 'Paid' | 'Refund';
  reasonOfCancel?: string;
  modeOfPayment?: string;
  invoiceStatus?: string;
  modeOfRefund?: string;
  canceledBillItems?: any[];
  cancelItems?: any[];
  canceledId?: string;
}

interface ErrorResponse {
  message: string;
  status?: number;
}

interface SuccessResponse {
  status: string;
  result: any;
  msg: string;
}

const editInvoiceByIdApi = createAsyncThunk<
  SuccessResponse,
  { body: EditInvoicePayload; id: string },
  { rejectValue: ErrorResponse }
>(
  'editInvoiceByIdApi',
  async ({ body, id }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const url = `${BILLING_ROUTES.INVOICE.edit}/${id}`;

      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update invoice');
      }

      const data = await response.json();

      return {
        status: 'success',
        result: data,
        msg: 'Invoice updated successfully',
      };
    } catch (error) {
      return rejectWithValue({
        message: error instanceof Error ? error.message : 'Unknown error',
        status: error instanceof Error ? undefined : (error as any).status,
      });
    }
  }
);

export default editInvoiceByIdApi;
